import { isEmpty, pathOr } from 'ramda';
import React, { FC, useCallback } from 'react';
import { SectionsLayout } from './RecommendedSectionsLayout/Sections';
import { MainSource } from '../../../constants/Source';
import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';
import { useTrackSearchAndFiltersAnalytics } from '../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import { IOuter } from './RecommendedItems.types';
import { useSections } from './useSections';
import styles from './RecommendedItems.scss';

export const RecommendedItems: FC<IOuter> = ({
  beginDrag,
  isItemSelected,
  onItemClick,
  openExpandedView,
  onItemRightClick,
  selectedItems,
  buyItem,
  onFileDoubleClick,
  items,
  currentFolder,
}) => {
  const { mmgrSettings } = useMMGRSettings();

  const { trackSearchAndFiltersShowAllClick } = useTrackSearchAndFiltersAnalytics();
  const sections = useSections(items);

  const handleShowAllClick = useCallback(
    (sectionIndex: number) => {
      const actionUrl = pathOr<string, string>(
        '',
        ['customData', 'sections', sectionIndex, 'action', 'url'],
        mmgrSettings,
      );

      trackSearchAndFiltersShowAllClick({
        clickOrigin: `${sectionIndex + 1}`,
        tabName: MainSource.Recommended,
        target: actionUrl,
      });
    },
    [trackSearchAndFiltersShowAllClick, mmgrSettings.customData],
  );

  return (
    <div className={styles.holder}>
      <div className={styles.scrollContainer}>
        <SectionsLayout
          sections={sections}
          selectedItems={selectedItems}
          rowsInSection={2}
          isItemSelected={isItemSelected}
          onItemClick={onItemClick}
          onItemRightClick={onItemRightClick}
          beginDrag={beginDrag}
          openExpandedView={openExpandedView}
          alwaysShowAction
          buyItem={buyItem}
          onFileDoubleClick={onFileDoubleClick}
          onShowAllClick={handleShowAllClick}
          currentFolder={currentFolder}
          hasSelectedItems={!isEmpty(selectedItems)}
        />
      </div>
    </div>
  );
};
